import React, { Component } from 'react';
import PropTypes from 'prop-types';
import syncPushState from '../../lib/syncPushState';
import Filter from './Filter';

export default class RadioFilter extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    options: PropTypes.array,
    selected: PropTypes.string,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func
  }

  static defaultProps = {
    options: [],
    selected: null,
    defaultValue: null,
    onChange() {}
  }

  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected,
    };
  }

  handleChange = (e) => {
    const selected = e.target.value;
    this.setState({ selected }, () => {
      syncPushState(this.props.id, selected);
      this.props.onChange('selected', { id: this.props.id, selected });
    });
  }

  handleLocalResetClick = () => {
    const selected = null;
    this.setState({ selected }, () => {
      syncPushState(this.props.id, selected);
      this.props.onChange('selected', { id: this.props.id, selected });
    });
  }

  handleGlobalResetClick = () => {
    const selected = null;
    this.setState({ selected }, () => {
      this.props.onChange('selected', { id: this.props.id, selected });
    });
  }

  render() {
    const { id, title, expanded, onChange } = this.props;
    return (
      <Filter
        id={id}
        title={title}
        expanded={expanded}
        hasSelected={this.state.selected !== null && this.state.selected !== this.props.defaultValue}
        onChange={onChange}
        onLocalReset={this.handleLocalResetClick}
        onGlobalReset={this.handleGlobalResetClick}
      >
        <div className="Form u-px-4 u-pb-2">
          {this.props.options.map((option) => {
            const checked = (this.state.selected === option.id) || (this.state.selected === null && this.props.defaultValue === option.id);
            return (
              <div className="radio" key={option.id}>
                <label htmlFor={option.id}>
                  <input
                    type="radio"
                    name={this.props.id}
                    key={option.id}
                    id={option.id}
                    className="u-m-0"
                    checked={checked}
                    value={option.id}
                    onChange={this.handleChange}
                  />
                  {option.name}
                </label>
              </div>
            );
          })}
        </div>
      </Filter>
    );
  }
}
